import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentRowToolbar from "../../../utils-components/document-row-toolbar";
import DocumentComments from "./document-comments";
import DocumentStatusSelect from "../../../utils-components/document-status-select";
import { mapActions, mapGetters } from "vuex";
import { DOWNLOAD_DOCUMENT, RENAME_DOCUMENT, DELETE_DOCUMENT_FROM_CLASSIFICATION, UPDATE_DOCUMENT_STATUS, SEND_DOCUMENT_COMMENT, MOVE_DOCUMENT, MARK_MESSAGES_AS_READ, EXTRACT_DOCUMENT_VALUES } from "../../../../store/documents-actions";
import { openFileDialog } from "../../../../../../../../../../shared/utils/utils";
import RenameDocumentModal from "../../modals/rename-document-modal";
import { APPLICATION_CLIENT_DETAILS, APPLICATION_CLIENT_FULL_NAME } from "../../../../../application/store/application-getters";
import DocumentPreviewModal from "@Shared/components/document-previewer/document-preview-modal.vue";
import { CURRENT_USER_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import UploadFilesModal from "@Broker/@Modules/util-components/upload-files-modal/upload-files-modal.vue";
import { showToast, DOCUMENT_CLASSIFICATIONS, DOCUMENT_CLASSIFICATIONS_FR, documentStatusIcons } from "@Shared/@Utils/constants";
import Err from "@Broker/js/routes/error";
import { DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION } from "@Broker/js/modules/clients/applications/documents/store/documents-getters";
import DocumentTags from "./document-tags.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import { isEmpty, pick, includes, values } from "lodash";
import { v4 as uuidv4 } from "uuid";
import DocumentExtractionModal from "./document-extraction-modal.vue";
import { validKeys } from "./document-extraction/document-extraction-utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRow",
  components: {
    DocumentRowToolbar,
    DocumentComments,
    DocumentStatusSelect,
    RenameDocumentModal,
    DocumentPreviewModal,
    UploadFilesModal,
    DocumentTags,
    ProfileAvatar,
    DocumentExtractionModal
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    document: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showComments: false,
      downloadingDocument: false,
      deletingDocument: false,
      editingDocument: false,
      loadingPreview: false,
      previewDocumentUrl: "",
      selectedClassification: {},
      uploading: false,
      uploadingSucceeded: false,
      labelValue: uuidv4(),
      shouldDelete: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [APPLICATION_CLIENT_FULL_NAME, APPLICATION_CLIENT_DETAILS])), mapGetters("AccountStore", [CURRENT_USER_DETAILS])), mapGetters("DocumentsStore", [DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION])), {}, {
    clientName() {
      return this.APPLICATION_CLIENT_FULL_NAME(this.clientUsername);
    },
    documentId() {
      return this.document.documentId;
    },
    documentRequestId() {
      return this.document.documentRequestId;
    },
    documentNumber() {
      return this.document.documentNumber;
    },
    isSample() {
      return this.document.isSample;
    },
    complete() {
      return this.document.requestStatus === "complete";
    },
    fileName() {
      return this.document.fileName;
    },
    createdAt() {
      return this.document.createdAt;
    },
    classificationType() {
      return this.document.classificationType;
    },
    uploaderUsername() {
      return this.document.uploaderUsername;
    },
    uploaderIsBroker() {
      return this.uploaderUsername === this.CURRENT_USER_DETAILS.username;
    },
    documentMetadata() {
      return this.document.metadata || {};
    },
    uploaderIsMainApplicant() {
      //if there is something in the metadata then is was not uploaded by main applicant
      if (this.documentMetadata.coApplicant) return false;
      return this.uploaderUsername === this.clientUsername;
    },
    uploaderDetails() {
      if (this.uploaderIsBroker) return this.CURRENT_USER_DETAILS;
      if (this.uploaderIsMainApplicant || isEmpty(this.documentMetadata)) return this.APPLICATION_CLIENT_DETAILS(this.clientUsername);
      return _objectSpread(_objectSpread({}, this.documentMetadata), {}, {
        username: this.documentMetadata.coApplicant
      });
    },
    move() {
      return this.DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION(this.applicationId).allIds.length > 1;
    },
    hasNewMessages() {
      return this.document.nrOfNewComments > 0;
    },
    showCommentsText() {
      const totalNewComments = this.document.nrOfNewComments;
      return this.hasNewMessages ? this.$tc("documents.newComment", totalNewComments, {
        number: totalNewComments
      }) : this.$options.filters.countComments(this.document, !this.showComments);
    },
    isExtractable() {
      var _context;
      const validValues = _flatMapInstanceProperty(_context = [DOCUMENT_CLASSIFICATIONS, DOCUMENT_CLASSIFICATIONS_FR]).call(_context, e => values(pick(e, validKeys)));
      return includes(validValues, this.document.classificationType);
    },
    statusIcon() {
      return documentStatusIcons[this.document.requestStatus] || "fa fa-file text-muted";
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT, RENAME_DOCUMENT, DELETE_DOCUMENT_FROM_CLASSIFICATION, UPDATE_DOCUMENT_STATUS, SEND_DOCUMENT_COMMENT, MOVE_DOCUMENT, MARK_MESSAGES_AS_READ, EXTRACT_DOCUMENT_VALUES])), {}, {
    toggleComments(value) {
      if (!this.showComments && this.hasNewMessages) {
        this.MARK_MESSAGES_AS_READ({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          documentRequestId: this.document.documentRequestId,
          documentId: this.document.documentId,
          documentNumber: this.document.documentNumber
        });
      }
      this.showComments = value != null ? value : !this.showComments;
    },
    async handleDownloadDocument() {
      this.downloadingDocument = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        fileName: this.fileName,
        documentId: this.documentId
      });
      openFileDialog(url, this.fileName);
      this.downloadingDocument = false;
    },
    showRenameDocumentModal() {
      this.$refs.renameDocumentModal.$showModal();
    },
    showPreviewDocumentModal() {
      this.$refs.previewDocumentModal.$showModal();
    },
    showMoveDocumentModal() {
      this.$refs.moveDocumentModal.openModal();
    },
    async handleEditDocument({
      fileName
    }) {
      this.editingDocument = true;
      await this.RENAME_DOCUMENT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        documentId: this.documentId,
        fileName
      });
      this.editingDocument = false;
    },
    async handleDeleteDocument() {
      this.deletingDocument = true;
      await this.DELETE_DOCUMENT_FROM_CLASSIFICATION({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        documentId: this.documentId,
        documentRequestId: this.documentRequestId,
        documentNumber: this.documentNumber,
        isSample: this.isSample
      });
      this.deletingDocument = false;
    },
    async handleDocumentComplete(status) {
      await this.UPDATE_DOCUMENT_STATUS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        documentId: this.documentId,
        documentRequestId: this.documentRequestId,
        documentNumber: this.documentNumber,
        requestStatus: status
      });
    },
    async handlePreviewClick() {
      this.loadingPreview = true;
      const {
        url
      } = await this.DOWNLOAD_DOCUMENT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        fileName: this.fileName,
        documentId: this.documentId
      });
      this.previewDocumentUrl = url;
      this.showPreviewDocumentModal();
      this.loadingPreview = false;
    },
    async handleCommentSubmit({
      comment
    }) {
      await this.SEND_DOCUMENT_COMMENT({
        applicationId: this.applicationId,
        documentId: this.documentId,
        comment,
        senderDetails: this.CURRENT_USER_DETAILS
      });
    },
    handlePreviewDocumentModalHide() {
      this.previewDocumentUrl = "";
    },
    handleClassificationSelection(classification) {
      this.selectedClassification = classification || {};
    },
    async handleMoveDocument() {
      this.uploading = true;
      try {
        await this.MOVE_DOCUMENT({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          documentRequestId: this.documentRequestId,
          documentId: this.documentId,
          documentNumber: this.documentNumber,
          newRequestId: this.selectedClassification.id
        });
        this.uploadingSucceeded = true;
        showToast("success", "documentMoved");
      } catch (e) {
        this.uploadingSucceeded = false;
        Err.handle(e);
      }
      this.uploading = false;
    },
    handleDelete(del) {
      this.shouldDelete = del;
    },
    showDocumentExtractionModal() {
      this.$refs.documentExtractionModal.$showModal();
    }
  })
});